"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFailed = void 0;
const types_1 = require("../../plugins/types");
const error_to_user_message_1 = require("../errors/error-to-user-message");
const format_with_changes_item_1 = require("./format-with-changes-item");
const format_unresolved_item_1 = require("./format-unresolved-item");
function formatFailed(failed) {
    if ((0, types_1.isWithError)(failed)) {
        return (0, format_unresolved_item_1.formatUnresolved)(failed.original, (0, error_to_user_message_1.convertErrorToUserMessage)(failed.error), failed.tip);
    }
    return (0, format_with_changes_item_1.formatChangesSummary)(failed.original, failed.changes);
}
exports.formatFailed = formatFailed;
//# sourceMappingURL=format-failed-item.js.map